<script setup lang="ts">

import { useRouter } from "vue-router";
import { ref, onMounted } from "vue";
import AxiosUserService from "../utils/axiosUserService";

const router= useRouter();
const axiosUserService = new AxiosUserService();
const userRole = localStorage.userRole

const user = ref()
async function getUser(){
    await axiosUserService.getCurrentUser(localStorage.token)
    .then(function (res) {      
         user.value = res.data

        // console.log('Current User Role',user.user_role)
    }).catch(function (res) {
        console.log('Current User error',res)    
    })
}

const openMenu = () =>{
    const d_sidebar:HTMLDivElement = document.querySelector('.d_sidebar') as HTMLDivElement
    d_sidebar.classList.add('open')

    onmouseup = (event: any) => { 
        if(d_sidebar !== event.target && !d_sidebar.contains(event.target)){
            d_sidebar.classList.remove("open");
        }
    };
}


onMounted(()=>{
    getUser();
})
</script>

<template>
    <nav class="d_sidebar transition flex column j-between a-start">
        <div class="navList dark">
            <div class="flex column a-center gap-10">
                <div class="flex a-center gap-5">
                    
                    <a href="/">
                        <img src="/new_mimir.png" alt="the Mimir">
                    </a>
                    <div class="tag bg-pr white">Debate</div>
                </div>

                <div class="d_avatar">
                    <img  class="avatar-sm" :src="user && user.avatar?.file_id ? `/api/v1/user/avatar/storage/${user.avatar?.file_id}`: '/avatar-default.png'" alt="">
                </div>
                <span class="db_head_4">{{ user?.nick_name }} </span>

                <div class="flex gap-10">
                    <router-link to="/"><span class="icon-home"></span></router-link>
                    <router-link to="/user"><span class="icon-boardcast"></span></router-link>
                    <router-link to="/user/profile" v-if="userRole == 'Mentor'"><span class="icon-user"></span></router-link>
                    <router-link to="/user/account" v-else><span class="icon-user " ></span></router-link>
                    <!-- <span class="icon-message"></span> -->
                </div>
            </div>




            <router-link class="navItem" to="/speak">

                <span class="icon-event"></span>
                <span>All Events</span>
            </router-link>
            <router-link class="navItem" to="/user/debate/activities">

                <span class="icon-host"></span>
                <span>Your Activities</span>
            </router-link>
            <!-- <router-link class="navItem" to="/user/debate/confirmation" >

                <span class="icon-invite"></span>
                <span>Application</span>
            </router-link> -->
            <router-link class="navItem" to="/user/debate/tickets">

                <span class="icon-ticket"></span>
                <span>Your Tickets</span>
            </router-link>
            <router-link class="navItem" to="/user/debate/material" >
                <span class="icon-files"></span>
                <span>Material </span>
            </router-link>
            <router-link class="navItem" to="/user/debate/qa" >
                <span class="icon-question"></span>
                <span>Q&A </span>
            </router-link>
            
            <!-- <router-link class="navItem" to="/user/archived" v-if="user.user_role == 'Free' || 'Premiun'">
                <span class="icon-docs"></span>
                <span>Archived</span>
            </router-link> -->
            <!-- <router-link class="navItem" to="/user/popularity" v-if="user.user_role == 'Mentor'"> 
                <span class="icon-stage"></span>
                <span>Popularity</span>
            </router-link> -->
            <!-- <router-link class="navItem" to="/user/curruculum" v-if="user.user_role == 'Mentor'">
                <span class="icon-lesson"></span>
                <span>Curruculum</span>
            </router-link> -->
        </div>
       
     

    </nav>
    <img class="mb_menu active transition abs pointer " src="/icon-menu.png" @click="openMenu">

</template>    

<style scoped>
@import '../assets/styles/dashboard.css';
</style>